import { createStyles, Grid, makeStyles } from '@material-ui/core';
import { Dialog, Typography } from '@nutrien/cxp-components';
import React from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    offlineGrid: {
      padding: '16px',
    },
    offlineMessage: {
      letterSpacing: '0.15px',
      padding: '24px 0px',
    },
  }),
);

const OfflineDialog: React.FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      titleText="Offline Message"
      backButton={false}
      maxWidth="xs"
      noMinHeight
      maxHeight="99vh"
    >
      <Grid className={classes.offlineGrid}>
        <Typography variant="h6" fontWeight={300} className={classes.offlineMessage}>
          This feature is only available in online mode, please connect to WiFi or move to an area
          with better internet connectivity.
        </Typography>
      </Grid>
    </Dialog>
  );
};

export default OfflineDialog;
